import { AuthContext } from 'auth/context/AuthContext';
import { useContext,useState } from 'react';
import { useNavigate,useLocation } from 'react-router-dom';
import { Button,Card,Form,Container,Row, Col } from "react-bootstrap";
import { MensajeAlerta} from '../components/Messages/MensajeAlerta';

export const ActualizarContrasena = () => {
    const navigate = useNavigate();
    const location = useLocation();
    
    let valoresLogin={
        Contrasena:'',
        ContrasenaConfirmacion:''
    }
    const {user,modificarPass}= useContext(AuthContext)
    const [valorLogin, setValoresLogin] = useState(valoresLogin);
    let mensajesAlerta={
        mensaje:'',
        estado:0
    }
    const [mensajeAlerta, setMensaje] = useState(mensajesAlerta);
    const onSend = async(event) => {
        event.preventDefault();
        const resp=await modificarPass(valorLogin);
       
        setMensaje({mensaje:resp.message,estado:resp.success})
    }
    const onCambio=(event)=>{
        setValoresLogin({ ...valorLogin, [event.target.name]: event.target.value });
    }
    const onContinue = () => {
        navigate('/admin/', {
            replace: true
        });
    }
    return (
    <>
        <div className="wrapper" style={{
                backgroundColor: "#444444",
            }}>
            <Container fluid>
             
            <Row>
            <Col md="4">
            </Col>
            <Col md="4">
                <Card className="mt-5">
                    <Card.Header className="">
                       
                    <div className="logo d-flex justify-content-center">
                    <a href="#" className="simple-text logo-mini mx-1">
                        <img
                            src="https://cordescorporacion.cl/wp-content/uploads/2021/10/newLogo.jpg"
                            alt="..."
                            width="220px" 
                            height="100px"
                        />
                    </a>
                    <a className="simple-text" href="https://cordescorporacion.cl">
                    </a>
                    </div>
                <br></br>
                    <Card.Title as="h4"></Card.Title>
                </Card.Header>
                <Card.Body>
                <Form>
                    <Row className="justify-content-center">
                        <Col md="6">
                            <Form.Group>
                            <label>Nueva Contraseña</label>
                            <Form.Control
                                name="Contrasena"
                                placeholder=""
                                type="text"
                                defaultValue={valoresLogin?.Contrasena}
                                onChange={onCambio}
                            >
                            </Form.Control>
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row className="justify-content-center">
                        <Col md="6">
                            <Form.Group>
                            <label>Confirme Contraseña</label>
                            <Form.Control
                                name="ContrasenaConfirmacion"
                                placeholder=""
                                type="text"
                                defaultValue={valoresLogin?.ContrasenaConfirmacion}
                                onChange={onCambio}
                            >
                            </Form.Control>
                            </Form.Group>
                        </Col>
                    </Row>
                    
                    <Row className="d-flex justify-content-center">
                        
                        <Col md="6" xs="12">
                        <Form.Group className="d-flex justify-content-end">
                            
                            <Button 
                                className="btn btn-primary mr-4"
                                onClick={ onSend }>
                                Modificar
                            </Button>
                            <Button 
                                className="btn btn-primary mr-4"
                                onClick={ onContinue }
                                disabled={!mensajeAlerta.estado}
                            >
                                Continuar 
                            </Button>
                        </Form.Group>
                           
                        </Col>
                    </Row>
                    <MensajeAlerta mensajeTexto={mensajeAlerta.mensaje} estado={mensajeAlerta.estado} />
                </Form>
                </Card.Body>
                </Card>
                </Col>
                <Col md="4">
            </Col>
            </Row>
            </Container>
        </div>
    </>
        
    )
}
export default ActualizarContrasena;
